module.exports = __webpack_public_path__ + "img/7.3d5fcfd1.jpg";